import { getMyBookedEvents } from '@guryou/api-client-gql';

import { ActionStatus, buildActionType } from '../core';
import { MY_BOOKED_EVENTS } from '../types';

const myBookedEventsAction = startDate => async dispatch => {
  dispatch({ type: buildActionType(MY_BOOKED_EVENTS, ActionStatus.START) });
  const response = await getMyBookedEvents(startDate);
  dispatch({ type: buildActionType(MY_BOOKED_EVENTS, ActionStatus.DONE), payload: { response } });
};

export { myBookedEventsAction };
